"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactClampLines = _interopRequireDefault(require("react-clamp-lines"));

var _useUserAgent = require("@oieduardorabelo/use-user-agent");

var _hooks = require("../../../hooks");

var _components = require("../../../components");

var _MenuCardModule = _interopRequireDefault(require("./MenuCard.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable react/no-multi-comp */


var MenuCard = function MenuCard(_ref) {
  var _details$device, _details$device2;

  var calories = _ref.calories,
      cellType = _ref.cellType,
      dataTest = _ref.dataTest,
      description = _ref.description,
      dietIcons = _ref.dietIcons,
      fallbackSrc = _ref.fallbackSrc,
      id = _ref.id,
      imageSrc = _ref.imageSrc,
      name = _ref.name,
      _onClick = _ref.onClick,
      placeholderSrc = _ref.placeholderSrc,
      price = _ref.price;
  var details = (0, _useUserAgent.useUserAgent)();

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      views = _useTemplate$useCell.views,
      labelTextStyles = _useTemplate$useCell.labelTextStyles,
      buttons = _useTemplate$useCell.buttons;

  var Img = /*#__PURE__*/_react["default"].createElement(_components.LazyImage, {
    Component: "div",
    alt: name,
    className: _MenuCardModule["default"].image,
    fallback: fallbackSrc,
    src: imageSrc,
    placeholder: placeholderSrc
  });

  return /*#__PURE__*/_react["default"].createElement(_components.View, {
    dataTest: dataTest,
    type: views.background,
    className: [_MenuCardModule["default"].menuItem, "menu-item"],
    onClick: _onClick,
    justify: "around"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _MenuCardModule["default"]["menuItem-header"]
  }, /*#__PURE__*/_react["default"].createElement("h3", null, /*#__PURE__*/_react["default"].createElement("a", {
    "aria-label": name || "",
    onClick: function onClick(e) {
      e.preventDefault();
      return _onClick;
    },
    href: "#"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    className: _MenuCardModule["default"]["menuItem-header--title"],
    type: labelTextStyles.primary
  }, /*#__PURE__*/_react["default"].createElement(_reactClampLines["default"], {
    id: id,
    buttons: false,
    text: name || "",
    lines: (details === null || details === void 0 ? void 0 : (_details$device = details.device) === null || _details$device === void 0 ? void 0 : _details$device.type) === "mobile" ? 3 : 2,
    ellipsis: "..."
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _MenuCardModule["default"]["menuItem-header--dietary"]
  }, dietIcons)), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary,
    className: _MenuCardModule["default"]["menuItem-desc"],
    title: description
  }, /*#__PURE__*/_react["default"].createElement(_reactClampLines["default"], {
    id: id,
    buttons: false,
    text: description || "",
    lines: (details === null || details === void 0 ? void 0 : (_details$device2 = details.device) === null || _details$device2 === void 0 ? void 0 : _details$device2.type) === "mobile" ? 4 : 3,
    ellipsis: "..."
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _MenuCardModule["default"]["menuItem-content"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _MenuCardModule["default"]["menuItem-content--row"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.tertiary,
    className: _MenuCardModule["default"].price
  }, price)), /*#__PURE__*/_react["default"].createElement(_components.Box, {
    justify: "center",
    className: _MenuCardModule["default"]["menuItem-content--info"]
  }, /*#__PURE__*/_react["default"].createElement(_components.View, {
    className: _MenuCardModule["default"]["menuItem-content--image-wrapper"],
    type: views.tertiary
  }, Img), /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: buttons.primary,
    className: _MenuCardModule["default"].atc
  }, "Add To Cart"))));
};

var _default = MenuCard;
exports["default"] = _default;